import { combineReducers } from 'redux';
import types from './types';

export const authentication = (state = {
  logged: false,
  loading: false,
  error: false,
  token: null,
  user: null,
}, action) => {
  // console.log('::::::REDUCER::USERS::authentication::', action);
  switch (action.type) {
    case types.GETAUTHREWARDS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case types.GETAUTHREWARDS_SUCCESS:
      return {
        ...state,
        error: false,
        user: {
          ...state.user,
          rewards: action.payload.data,
        } 
      };
    case types.FORGOT_REQUEST:
    case types.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        loggin: action.username,
      };
    case types.VERIFY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case types.VERIFY_RETRY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      }; 
    case types.LOGIN_SUCCESS:
      return {
        logged: true,
        loading: false,
        error: false,
        token: action.payload.token,
        user: action.payload.user,
      };
    case types.FORGOT_FAILURE:
    case types.LOGIN_FAILURE:
    case types.VERIFY_FAILURE:
    case types.VERIFY_RETRY_FAILURE:
        return { 
        ...state,
        loading: false,
        error: action.error,
        token: null,
        user: null,
      };
    case types.FORGOT_SUCCESS:
    case types.LOGOUT:
      return {
        ...state,
        logged: false,
        loading: false,
        token: null,
        user: null,
      };
    // case types.LOGGED:
    //   return {
    //     ...state,
    //     logged: true,
    //     loading: false,
    //     user: action.user
    //   };
    case types.GETREWARDS_REQUEST:
    default:
      return state
  }
}

export const registration = (state = {}, action) => {
  // console.log('::::::REDUCER::USERS::registration::', action);
  switch (action.type) {
    case types.REGISTER_REQUEST:
      return { registering: true };
    case types.REGISTER_SUCCESS:
      return {};
    case types.REGISTER_FAILURE:
      return {};
    default:
      return state
  }
}

export const user = (state = {
  item: null,
  loading: false,
  error: null,
  balance: null,
}, action) => {
  // console.log('::::::REDUCER::USERS::user::', action);
  switch (action.type) {
    case types.GETREWARDS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case types.GETREWARDS_SUCCESS:
      return {
        ...state,
        error: false,
        item: {
          ...state.item,
          rewards: action.payload.data,
        } 
      };
    case types.GET_REQUEST:
    case types.SAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_FAILURE:
    case types.SAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.SAVE_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.GET_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    case types.CLEAR_CURRENT:
      return {
        ...state,
        item: null,
      }
    case types.GETRANKING_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    case types.GETBALANCE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GETBALANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        balance: action.payload.data,
      };
    case types.GETBALANCE_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state
  }
}

export const users = (state = {
  loading: false,
  items: [],
  error: null,
  ranking: [],
}, action) => {
  // console.log('::::::REDUCER::USERS::users::', action);
  switch (action.type) {
    case types.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data,
      };
    case types.GETALL_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    case types.GETRANKING_REQUEST:
      return {
        ...state,
        loading: true
      };
    case types.GETRANKING_SUCCESS:
      return {
        ...state,
        loading: false,
        ranking: action.payload.data,
      };
    case types.GETRANKING_FAILURE:
      return { 
        ...state,
        loading: false,
        error: action.error
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(item =>
          item.id === action.id
            ? { ...item, deleting: true }
            : item
        )
      };
    case types.DELETE_SUCCESS:
      // remove deleted item from state
      return {
        ...state,
        error: null,
        items: state.items.filter(item => item.id !== action.id)
      };
    case types.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to item 
      return {
        ...state,
        error: action.error,
      };
    default:
      return state
  }
}

export const invites = (state = {
  loading: false,
  invites: [],
  error: null,
}, action) => {
  // console.log('::::::REDUCER::USERS::users::', action);
  switch (action.type) {
    case types.GETINVITES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GETINVITES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.GETINVITES_SUCCESS:
      return {
        ...state,
        invites: action.payload.data.invites,
        loading: false,
        error: null,
      };
    default:
      return state
   }
}


export default combineReducers({
  auth: authentication,
  register: registration,
  current: user,
  list: users,
  invites: invites
});

